var assert = require('nanoassert')
var cipher = require('./cipher')

class CipherState {
  constructor() {
    this.k = null
    this.n = 0
  }

  initializeKey(key) {
    assert(key.length === 32)
    this.k = key
    this.n = 0
  }

  hasKey() {
    return this.k != null
  }

  setNonce(n) {
    if (this.n > 0xFFFFFFFF) throw new Error('nonce overflow' + this.n)
    this.n = n
  }

  encryptWithAd(ad, plaintext) {
    if (this.hasKey() === false) {
      return plaintext.slice(0)
    }

    var k = this.k
    var n = this._nonceBytes()
    this._incNonce()

    return cipher.encrypt(k, n, ad, plaintext)
  }

  decryptWithAd(ad, ciphertext) {
    if (this.hasKey() === false) {
      return ciphertext.slice(0)
    }

    var k = this.k
    var n = this._nonceBytes()
    this._incNonce()

    return cipher.decrypt(k, n, ad, ciphertext)
  }

  rekey() {
    this.k = cipher.rekey(this.k)
  }

  _incNonce() {
    this.n++
    if (this.n > 0xFFFFFFFF) throw new Error('nonce overflow' + this.n)
  }

  _nonceBytes() {
    var buf = Buffer.alloc(8)
    buf.writeUInt32BE(this.n, 4)
    return buf
  }
}

module.exports = { CipherState }